
//cSpell: ignore putaoid,

import request from '../lib/request';
import utils from '../lib/utils';
import { reqAPI } from './reqAPI';

// 保存用户信息，供cocos用
export const setUserStorage = (user) => {
    if (user.eng_name && user.eng_name.length) {
        window.localStorage.setItem("kidName", user.eng_name);
    }
    if (typeof user.pauseButton === "number") {
        window.localStorage.setItem("pauseButton", user.pauseButton);
    }
    if (typeof user.pauseButton === "number") {
        window.localStorage.setItem("pauseButton", user.pauseButton);
    }
    if (typeof user.gender === "number") {
        window.localStorage.setItem("gender", user.gender);   // //性别 1女 0男
    }
}

export const getUserInfo = (params) => {
    return new Promise((resolve, reject) => {
        request(reqAPI.user_info, params, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                abnormalReporting({
                    putaoid: params.putaoid,
                    url: reqAPI.user_info,
                    type: 'data',
                    res
                });
                setUserStorage(res);
                resolve(res);
            })
            .catch(() => { reject() });
    });
}

export const getMedalInfo = (params) => {
    return new Promise((resolve, reject) => {
        request(reqAPI.medal_info, params, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                abnormalReporting({
                    putaoid: params.putaoid,
                    url: reqAPI.medal_info,
                    type: 'data',
                    res
                });
                resolve(res);
            })
            .catch(() => { reject() });
    });
}

export const getNeedShowChooseLevel = (params) => {
    return new Promise((resolve, reject) => {
        request(reqAPI.default_level, params, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                abnormalReporting({
                    putaoid: params.putaoid,
                    url: reqAPI.default_level,
                    type: 'data',
                    res
                });
                resolve(res);
            })
            .catch(() => { reject() });
    });
}

export const abnormalReporting = ({ res, putaoid, url, type, err }) => {
    if (type && type === 'data') {
        if (res && res.code === 499) {
            goLogin();
        } else {
            if (res && res.code && res.code !== 200) {
                if (res.msg) {
                    utils.showTips(res.msg, 5000);
                }

                try {
                    window.PTMonitor.report(
                        {
                            type: 'apiSucEx',
                            url: window.location.href,
                            putaoid: res,
                            info: res,
                            stack: url,
                        },
                        window.EX_TYPE.apiSucEx
                    );
                } catch (err) { }
            }
        }
    } else {
        utils.showTips('数据异常，请重试', 5000);

        try {
            window.PTMonitor.report(
                {
                    type: 'apiEx',
                    url: window.location.href,
                    putaoid: putaoid,
                    info: err,
                    stack: url,
                },
                window.EX_TYPE.apiEx
            );
        } catch (err) { }
    }
}

export const goLogin = () => {
    let _hash = window.location.hash;
    if (_hash.indexOf("#/login") === -1 && _hash.indexOf("#/register") === -1) {
        window.location.replace(
            `#/login?url=${encodeURIComponent(window.location.href)}&login_from=pc`
        );
    }
}

// 顺序执行 promise
export const mergePromise = (ajaxArray) => {
    let p = Promise.resolve();
    let arr = [];
    ajaxArray.forEach(promise => {
        p = p.then(promise).then((data) => {
            arr.push(data);
            return arr;
        });
    });
    return p;
}

// 专项课，cid是2000以上的，防止以后出现 3000甚至其他的，在这统一修改
export const specialCourse = (id) => {
    if (!id) {
        return 0;
    }
    if (typeof id !== "number" && id.indexOf("_") > -1) {
        return id.split("_")[0] > 2000 ? id.split("_")[0] : 0;
    } else {
        return id > 2000 ? id : 0;
    }
}


// WEBPACK FOOTER //
// ./src/server/commonFun.js